/* Perfora birthday — confetti burst when the cart drawer opens.
   Self-contained (no library, no network). The cart drawer is a custom element
   whose openDrawer() sets an `open` attribute, so we watch that attribute
   rather than hooking the theme's JS. The element is vendor-prefixed and the
   prefix differs by theme version — <sht-cart-drwr> on the live lineage,
   <ecx-cart-drwr> on Blum ESG — so both are matched here. */
(function () {
  'use strict';

  var SELECTOR = 'sht-cart-drwr, #shtCartDrawer, ecx-cart-drwr, #ecxCartDrawer';
  var COOLDOWN = 1500;
  var COLORS = ['#6C5CE7', '#B8A8F5', '#FFCF5C', '#F3C6D6', '#4A3BBF', '#FFFFFF'];

  if (window.__perforaCartConfetti) return;
  window.__perforaCartConfetti = true;

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var lastFired = 0;

  function burst() {
    var now = Date.now();
    if (reduced || document.hidden || now - lastFired < COOLDOWN) return;
    lastFired = now;

    var canvas = document.createElement('canvas');
    canvas.setAttribute('aria-hidden', 'true');
    canvas.style.cssText =
      'position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:2147483000';
    document.body.appendChild(canvas);

    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w, h;
    function size() {
      w = canvas.clientWidth;
      h = canvas.clientHeight;
      canvas.width = w * dpr;
      canvas.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    size();
    window.addEventListener('resize', size);

    // Two cones firing inward from the lower corners, so the confetti arcs up
    // across the drawer rather than raining over the whole page.
    var bits = [];
    [
      { x: w * 0.12, y: h * 0.98, dir: -0.55 },
      { x: w * 0.88, y: h * 0.98, dir: -2.6 }
    ].forEach(function (origin) {
      for (var i = 0; i < 55; i++) {
        var angle = origin.dir + (Math.random() - 0.5) * 0.9;
        var speed = 9 + Math.random() * 11;
        bits.push({
          x: origin.x,
          y: origin.y,
          vx: Math.cos(angle) * speed,
          vy: Math.sin(angle) * speed,
          w: 6 + Math.random() * 6,
          h: 9 + Math.random() * 7,
          color: COLORS[(Math.random() * COLORS.length) | 0],
          rot: Math.random() * Math.PI,
          spin: (Math.random() - 0.5) * 0.35,
          life: 0,
          ttl: 90 + Math.random() * 50
        });
      }
    });

    function frame() {
      ctx.clearRect(0, 0, w, h);
      var alive = 0;
      for (var i = 0; i < bits.length; i++) {
        var b = bits[i];
        if (b.life > b.ttl) continue;
        alive++;
        b.life++;
        b.vy += 0.32;         // gravity
        b.vx *= 0.99;         // drag
        b.vy *= 0.99;
        b.x += b.vx;
        b.y += b.vy;
        b.rot += b.spin;

        var fade = b.life > b.ttl - 25 ? (b.ttl - b.life) / 25 : 1;
        ctx.save();
        ctx.globalAlpha = Math.max(fade, 0);
        ctx.translate(b.x, b.y);
        ctx.rotate(b.rot);
        ctx.fillStyle = b.color;
        // Flip the width with the spin so each piece reads as a tumbling ribbon.
        ctx.fillRect(-b.w / 2, -b.h / 2, b.w * Math.abs(Math.cos(b.rot)), b.h);
        ctx.restore();
      }
      if (alive) {
        requestAnimationFrame(frame);
      } else {
        window.removeEventListener('resize', size);
        canvas.remove();
      }
    }
    requestAnimationFrame(frame);
  }

  function watch(el) {
    if (el.__confettiWatched) return;
    el.__confettiWatched = true;
    var wasOpen = el.hasAttribute('open');
    new MutationObserver(function () {
      var isOpen = el.hasAttribute('open');
      if (isOpen && !wasOpen) burst();
      wasOpen = isOpen;
    }).observe(el, { attributes: true, attributeFilter: ['open'] });
  }

  function scan() {
    var found = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < found.length; i++) watch(found[i]);
    return found.length > 0;
  }

  function start() {
    if (scan()) return;
    // The drawer is server-rendered, but some apps inject it late — retry briefly.
    var tries = 0;
    var timer = setInterval(function () {
      if (scan() || ++tries > 20) clearInterval(timer);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
